const DESKTOP_MEDIA = window.matchMedia('(min-width: 990px)');
const HEADER_SELECTOR = '#header-component[data-zelta-split-header="true"]';

function desiredMenuMode() {
  return DESKTOP_MEDIA.matches ? 'menu' : 'drawer';
}

function keepSplitHeaderInCorrectMode(header) {
  const update = () => {
    const desired = desiredMenuMode();

    if (header.dataset.menuStyle !== desired) {
      header.dataset.menuStyle = desired;
    }
  };

  update();

  const observer = new MutationObserver(update);

  observer.observe(header, {
    attributes: true,
    attributeFilter: ['data-menu-style'],
  });

  header.zeltaMenuModeObserver = observer;
}

function hideAllPanels(menu) {
  menu.querySelectorAll('[data-zelta-panel]').forEach((panel) => {
    panel.hidden = true;
  });
}

function clearPreviewState(menu) {
  menu.querySelectorAll('[data-zelta-preview-link]').forEach((link) => {
    link.classList.remove('is-preview-active');
  });
}

function showPanel(menu, panelId) {
  if (!panelId) {
    hideAllPanels(menu);
    menu.dataset.zeltaPanelActive = 'false';
    return false;
  }

  let matchedPanel = false;

  menu.querySelectorAll('[data-zelta-panel]').forEach((panel) => {
    const isMatch = panel.id === panelId;

    panel.hidden = !isMatch;

    if (isMatch) {
      matchedPanel = true;
    }
  });

  menu.dataset.zeltaPanelActive = matchedPanel ? 'true' : 'false';

  return matchedPanel;
}

function setActivePreview(menu, activeLink, moveFocus = false) {
  const panelId = activeLink.dataset.zeltaPreviewPanel;

  if (!panelId) return;

  clearPreviewState(menu);

  activeLink.classList.add('is-preview-active');
  showPanel(menu, panelId);

  if (moveFocus) {
    activeLink.focus();
  }
}

function initializePreviewMenu(menu) {
  if (menu.dataset.zeltaTabsReady === 'true') return;

  const links = [
    ...menu.querySelectorAll('[data-zelta-preview-link]'),
  ];

  if (links.length === 0) return;

  menu.dataset.zeltaTabsReady = 'true';

  const initialLink =
    links.find((link) => link.getAttribute('aria-current') === 'page') ||
    links.find((link) => link.classList.contains('is-current')) ||
    links[0];

  setActivePreview(menu, initialLink);

  links.forEach((link, index) => {
    link.addEventListener('pointerenter', (event) => {
      if (event.pointerType !== 'touch') {
        setActivePreview(menu, link);
      }
    });

    link.addEventListener('focus', () => {
      setActivePreview(menu, link);
    });

    link.addEventListener('keydown', (event) => {
      let nextIndex = index;

      if (event.key === 'ArrowDown') {
        nextIndex = (index + 1) % links.length;
      } else if (event.key === 'ArrowUp') {
        nextIndex = (index - 1 + links.length) % links.length;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = links.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      setActivePreview(menu, links[nextIndex], true);
    });
  });
}

function initializeHeader(header) {
  if (header.dataset.zeltaMenuReady === 'true') return;

  header.dataset.zeltaMenuReady = 'true';

  keepSplitHeaderInCorrectMode(header);

  const detailsElements = [
    ...header.querySelectorAll('[data-zelta-menu-details]'),
  ];

  detailsElements.forEach((details) => {
    const summary = details.querySelector(
      ':scope > [data-zelta-menu-summary]'
    );

    const menu = details.querySelector('[data-zelta-tabs]');

    if (menu) {
      initializePreviewMenu(menu);
    }

    details.addEventListener('toggle', () => {
      if (summary) {
        summary.setAttribute(
          'aria-expanded',
          String(details.open)
        );
      }

      if (details.open) {
        detailsElements.forEach((otherDetails) => {
          if (otherDetails !== details) {
            otherDetails.open = false;
          }
        });

        header.dataset.zeltaMegaMenuOpen = 'true';

        if (menu) {
          const activeLink =
            menu.querySelector(
              '[data-zelta-preview-link].is-preview-active'
            ) ||
            menu.querySelector('[data-zelta-preview-link]');

          if (activeLink) {
            setActivePreview(menu, activeLink);
          }
        }
      } else if (
        !detailsElements.some((item) => item.open)
      ) {
        delete header.dataset.zeltaMegaMenuOpen;
      }
    });
  });
}

function initializeAllHeaders(root = document) {
  const headers = [];

  if (
    root instanceof Element &&
    root.matches(HEADER_SELECTOR)
  ) {
    headers.push(root);
  }

  root
    .querySelectorAll?.(HEADER_SELECTOR)
    .forEach((header) => {
      headers.push(header);
    });

  headers.forEach(initializeHeader);
}

function closeOpenMenus(event) {
  document
    .querySelectorAll(
      `${HEADER_SELECTOR} [data-zelta-menu-details][open]`
    )
    .forEach((details) => {
      if (
        event?.target instanceof Node &&
        details.contains(event.target)
      ) {
        return;
      }

      details.open = false;
    });
}

document.addEventListener(
  'pointerdown',
  closeOpenMenus
);

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    const openDetails = document.querySelector(
      `${HEADER_SELECTOR} [data-zelta-menu-details][open]`
    );

    const summary = openDetails?.querySelector(
      ':scope > [data-zelta-menu-summary]'
    );

    closeOpenMenus();

    summary?.focus();
  }
);

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeAllHeaders(event.target);
  }
);

DESKTOP_MEDIA.addEventListener(
  'change',
  () => {
    document
      .querySelectorAll(HEADER_SELECTOR)
      .forEach((header) => {
        header.dataset.menuStyle =
          desiredMenuMode();
      });

    closeOpenMenus();
  }
);

initializeAllHeaders();
